import { render, staticRenderFns } from "./f-integer.vue?vue&type=template&id=3d4a0e5a&lang=pug&"
import script from "./f-integer.vue?vue&type=script&lang=js&"
export * from "./f-integer.vue?vue&type=script&lang=js&"
import style0 from "./f-integer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d4a0e5a')) {
      api.createRecord('3d4a0e5a', component.options)
    } else {
      api.reload('3d4a0e5a', component.options)
    }
    module.hot.accept("./f-integer.vue?vue&type=template&id=3d4a0e5a&lang=pug&", function () {
      api.rerender('3d4a0e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/fields/f-integer.vue"
export default component.exports